/**** Custom Script Js ****/

// Home Banner Scripts
$(document).ready(function () {
  $('.custom-slideshow1.home_slider .slideshow-content').each(function (index) {
    var $content = $(this);
    var $textWrapper = $('.slideshow__text-wrapper.banner__content').eq(index);

    if ($textWrapper.length) {
      $textWrapper.detach().appendTo($content);
    }
  });
});


// Footer Map Image Scripts
$(document).ready(function () {
  $('.footer-block.footer__item--text_PrVJLP .footer_link').attr('href', 'https://maps.app.goo.gl/KwzVSDyFqhdckarR6', 'target', '_blank');
  $('.footer-block.footer__item--text_PrVJLP .footer_link').attr('target', '_blank');
});


// Move specification section button below the center image
$(document).ready(function () {
  $('.specification-block .title-wrapper-with-link .button').appendTo('.specification-banner .specification-block-main-grid');
});


// Replace tag to js
document.addEventListener("DOMContentLoaded", function () {
  const oldHeading = document.querySelector(".jdgm-rev-widg__header h2.jdgm-rev-widg__title");
  if (oldHeading) {
    const newHeading = document.createElement("h6");
    newHeading.className = "jdgm-rev-widg__title";
    newHeading.innerHTML = oldHeading.innerHTML;
    oldHeading.parentNode.replaceChild(newHeading, oldHeading);
  }
});